import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-owf_r2r_create_referral_link-submit';
/**
 * Event that fires for OwF R2R when the referral link between a referring retailer and a referred retailer is set to be made
 */
export function trackOpenWithFaireOwfR2RCreateReferralLinkSubmit() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
